import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import MerchandiserNotifications from "components/menu/dashboard/merchandiser/merchandiser-notifications";
import MerchandiserServices from "components/menu/dashboard/merchandiser/merchandiser-services";

class MerchandiserDashboard extends React.Component {
    render () {
        return (
            <div className="dashboard merchandiser-dashboard row">
                <div className="col-12">
                    <MerchandiserNotifications />
                </div>
                <div className="col-12 mt-4">
                    <MerchandiserServices />
                </div>
            </div>
        );
    }
}

MerchandiserDashboard.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps
)(MerchandiserDashboard);
